import {
  validateLabel,
  validateDescription,
  validatePrimaryColor,
  validateSecondaryColor,
  validateStartTime,
  validateEndTime,
} from "#shared/inputValidation/inputValidation.js";

export const validateFileInterval = (currentInterval, setFileError, index) => {
  const labelValid = validateLabel(currentInterval.label);
  if (labelValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " + (index + 1) + ": " + labelValid.errorMessages[0],
        ],
      };
    });
  }
  const descriptionValid = validateDescription(currentInterval.description);
  if (descriptionValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " + (index + 1) + ": " + descriptionValid.errorMessages[0],
        ],
      };
    });
  }
  const primaryColorValid = validatePrimaryColor(currentInterval.primaryColor);
  if (primaryColorValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " + (index + 1) + ": " + primaryColorValid.errorMessages[0],
        ],
      };
    });
  }
  const secondaryColorValid = validateSecondaryColor(
    currentInterval.secondaryColor,
  );
  if (secondaryColorValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " +
            (index + 1) +
            ": " +
            secondaryColorValid.errorMessages[0],
        ],
      };
    });
  }
  const startTimeValid = validateStartTime([
    currentInterval.startTime,
    currentInterval.endTime,
  ]);
  if (startTimeValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " + (index + 1) + ": " + startTimeValid.errorMessages[0],
        ],
      };
    });
  }
  const endTimeValid = validateEndTime([
    currentInterval.startTime,
    currentInterval.endTime,
  ]);
  if (endTimeValid.errorClass === "invalid") {
    setFileError((prevObject) => {
      return {
        ...prevObject,
        errorClass: "invalid",
        errorMessages: [
          ...prevObject.errorMessages,
          "Interval " + (index + 1) + ": " + endTimeValid.errorMessages[0],
        ],
      };
    });
  }
  const labelValidBoolean = labelValid.errorClass === "valid";
  const descriptionValidBoolean = descriptionValid.errorClass === "valid";
  const primaryColorValidBoolean = primaryColorValid.errorClass === "valid";
  const secondaryColorValidBoolean = secondaryColorValid.errorClass === "valid";
  const startTimeValidBoolean = startTimeValid.errorClass === "valid";
  const endTimeValidBoolean = endTimeValid.errorClass === "valid";
  const allValid =
    labelValidBoolean &&
    descriptionValidBoolean &&
    primaryColorValidBoolean &&
    secondaryColorValidBoolean &&
    startTimeValidBoolean &&
    endTimeValidBoolean;
  return allValid;
};
